import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useStore } from '@hooks';
import { Loader } from '@ui';
import { observer } from 'mobx-react';
import SetupWizard from '../../../../components/SetupWizard';
import { StyledLoaderWrapper } from '../../styled';
import Connected from '../Connected';
import NotConnected from '../NotConnected';

const Shopify = observer(() => {
    const store = useStore();
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const { getShopifyAccountPerformance, shopDomain, performanceList, overviewPending } = store.performanceStore;
    const showModalSetup = !!location.state?.showModalSetup;

    useEffect(() => {
        (async () => {
            await getShopifyAccountPerformance();
        })();
    }, []);

    const handleSetupDone = () => {
        const next = new URLSearchParams(searchParams);
        next.delete('setup');
        setSearchParams(next, { replace: true });
    };

    if (overviewPending) {
        return (
            <StyledLoaderWrapper>
                <Loader size='120px' />
            </StyledLoaderWrapper>
        );
    }

    if (!performanceList.length) {
        return (
            <React.Fragment>
                {showModalSetup ? <SetupWizard onDone={handleSetupDone} /> : null}
                <NotConnected />
            </React.Fragment>
        );
    }

    return (
        <Connected
            handleSetupDone={handleSetupDone}
            showModalSetup={showModalSetup}
            isShopify
            pendingMetricsOverview={overviewPending}
            shopDomain={shopDomain}
            performanceList={performanceList}
        />
    );
});

export default Shopify;
